import React from 'react';

import { Link } from 'react-router';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';

import values from 'lodash/values';
import get from 'lodash/get';

import { namespace, actions, selectors } from './';

import wrapMain from '../../wrap-main';

import InputField from '../../../shared/form-elements/input';
import SelectField from '../../../shared/form-elements/select/field';
import Textarea from '../../../shared/form-elements/textarea';
import { isRequired, isSelected } from '../../../shared/form/validation';

import { enum as languages } from '../../../../../../../enums/languages';

import EditorField from './editor-field/main';

function Editor({ intl, articleTagsLookup, ...props }) {
	const lang = get(props.formValues, 'language[0].value', null);
	return (
		<div className='form-container'>
			<div className='form-container__head'>
				<h2 className='icon-edit'>
					{intl('create/edit article')}
				</h2>
			</div>
			<div className='form-container__body'>
				<form onSubmit={props.handleSubmit}>
					<Field
						name='tags'
						component={SelectField}
						validate={[isSelected]}
						searchable={true}
						multi={true}
						options={articleTagsLookup}
						placeholder={intl('Tags')}
					/>
					<div className='blog-article-tag-editor'>
						<Field
							name='language'
							component={SelectField}
							validate={[isSelected]}
							searchable={false}
							options={values(languages).map((lang) => ({
								label: lang,
								value: lang
							}))}
							placeholder={intl('Language')}
						/>
					</div>
					<div className='banners-fields-horizontally'>
						<Field
							className='banners-info-field banners-image-field'
							name='image'
							component={InputField}
							validate={[isRequired]}
							placeholder={intl('Image')}
						/>
						<Link
							className='banners-search'
							to={lang ? `/blog/article-images?langs=${lang}` : '/blog/article-images'}
							target='_blank'
						/>
					</div>
					<div className='blog-article-tag-editor'>
						<Field
							name='title'
							component={InputField}
							validate={[isRequired]}
							placeholder={intl('Title')}
						/>
					</div>
					<div className='blog-article-tag-editor'>
						<Field
							name='description'
							component={Textarea}
							validate={[isRequired]}
							placeholder={intl('Description')}
							initialHeight={55}
							minHeight={55}
						/>
					</div>
					<div className='blog-article-tag-editor'>
						<Field
							name='content'
							component={EditorField}
						/>
					</div>
					<div className='banners-buttons'>
						<button className='ui-btn ui-btn-primary'>
							{intl('Save')}
						</button>
						<Link
							className='ui-btn ui-btn-cancel'
							to='/blog/article-tags'
						>
							{intl('Cancel')}
						</Link>
					</div>
				</form>
			</div>
		</div>
	);
}

function mapStateToProps(state) {
	return {
		initialValues: selectors.select(state, 'data'),
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		// -----------------------------------------
		formValues: getFormValues(`${namespace}Form`)(state)
	};
}

const Main = reduxForm({ form: `${namespace}Form`, enableReinitialize: true })(Editor);

export default connect(mapStateToProps, actions.own)(wrapMain(Main));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/article/editor/main.js